
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SearchInput extends Vue {
  @Prop({ default: 'Button' }) SearchType!: string;
  @Prop({ default: '请输入作品名或作者' }) placeholder!: string;
  @Prop({ default: '#366ed8' }) buttonBg!: string;

  InputData(e: any) {
    this.$emit('fetchSearch', e.target.value);
  }
  onSubmit(e: any) {
    this.$emit('startSearch');
  }
}
